// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".filter-actions[data-v-4d4b0712]{font-family:inherit!important;width:225px}.filter-title[data-v-4d4b0712]{font-weight:700}.filter-options[data-v-4d4b0712] .dx-texteditor-input,.filter-options[data-v-4d4b0712] .dx-widget{font-family:inherit!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
